import { useState } from 'react'

import cn from '@components/utils/cn'
import { useIsTruncated } from '@hooks/useIsTruncated'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.expandable_text')

const TOGGLE_CLASSES =
  'tw:shrink-0 tw:rounded-full tw:bg-gray-100 tw:px-2 tw:text-xs tw:font-medium tw:leading-5 tw:text-gray-600 tw:hover:bg-gray-200 tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-300'

export type ExpandableTextProps = {
  text: string
  expandLabel: string
}

export function ExpandableText({ text, expandLabel }: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false)
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>({ paused: expanded })

  return (
    <div className="tw:flex tw:min-w-0 tw:items-start tw:gap-1.5 tw:text-sm tw:text-gray-500">
      <span ref={ref} className={cn('tw:min-w-0', expanded ? 'tw:whitespace-normal' : 'tw:truncate')}>
        {text}
      </span>
      {isTruncated && (
        <button
          type="button"
          className={TOGGLE_CLASSES}
          aria-label={expanded ? undefined : expandLabel}
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? t('show_less') : '…'}
        </button>
      )}
    </div>
  )
}
